interface CheckIconProps {
  className?: string
}

export default function CheckIcon({ className = '' }: CheckIconProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
    >
      <path
        d="M1.33301 6.3327L3.66634 8.66604L10.6663 1.3327"
        stroke="#896145"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
